import { type ChangeEventHandler, forwardRef } from 'react'
import { Box, type BoxProps } from '../Box'
import { textareaCss, mediumInput, smallInput } from './Textarea.css'

interface TextareaProps {
  onChange?: ChangeEventHandler<HTMLTextAreaElement>
  size?: 'small' | 'medium'
}

type Props = Omit<BoxProps, keyof TextareaProps | 'children'> & TextareaProps

export const Textarea = forwardRef<HTMLTextAreaElement, Props>(
  ({ type = 'text', className, size = 'medium', ...props }, ref) => {
    return (
      <Box
        as="textarea"
        width="100%"
        textAlign="inherit"
        ref={ref}
        className={[
          className,
          textareaCss,
          {
            [smallInput]: size === 'small',
            [mediumInput]: size === 'medium',
          },
        ]}
        {...props}
      />
    )
  },
)

Textarea.displayName = 'Textarea'
